export default __webpack_public_path__ + "static/media/09.a1f10b7a.jpg";